import {Component, Inject, Input, OnInit, Optional, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';
import {animations} from '../../class';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {DateAdapter} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-date',
  template: `
    <div style="width:auto;">
      <label *ngIf="label" [attr.for]="identifier"
             style="float: left;padding-right: 8px"
             class="col-form-label">{{label}}</label>

      <mat-form-field floatLabel="never">
        <input matInput type="text"
               [matDatepicker]="myDatepicker"
               appMaskDate
               [placeholder]="placeholder"
               [max]="maxDate"
               [min]="minDate"
               [disabled]="disabled"
               [(ngModel)]="value"
               name="{{identifier}}"
        />
        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #myDatepicker></mat-datepicker>
      </mat-form-field>
    </div>
  `,

  animations,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: DateComponent,
    multi: true,
  }],
})

export class DateComponent implements OnInit, ControlValueAccessor {
  @Input() public label: string;
  @Input() public placeholder: string;
  @Input() public disabled: boolean;
  @Input() public required: boolean;
  @Input() public maxDate: any;
  @Input() public minDate: any;

  @ViewChild(NgModel) model: NgModel;
  public identifier = `form-date-${identifier++}`;

  private innerValue: Date;

  private changed = new Array<(value: number) => void>();
  private touched = new Array<() => void>();

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private _adapter: DateAdapter<any>,
    private _translateService: TranslateService
  ) {
    // super(validators, asyncValidators);
  }

  ngOnInit() {
    this._adapter.setLocale(this._translateService.currentLang);
  }

  onSelectDate(date: Date) {
  }


  get value(): Date {
    return this.innerValue;
  }

  set value(value: Date) {
    if (this.innerValue !== value) {
      this.innerValue = value;
      if (value) {
        this.changed.forEach(f => f(value.getTime()));
      } else {
        this.changed.forEach(f => f(null));
      }
    }
  }

  writeValue(value: Date) {
    if (value) {
      this.innerValue = new Date(value);
    }

  }

  registerOnChange(fn: (value: any) => void) {
    this.changed.push(fn);
  }

  registerOnTouched(fn: () => void) {
    this.touched.push(fn);
  }

  touch() {
    this.touched.forEach(f => f());
  }

}

let identifier = 0;



// WEBPACK FOOTER //
// ./src/app/modules/forms/components/date/date.component.ts